import { render, staticRenderFns } from "./ModalNormativa.vue?vue&type=template&id=6bee697e&scoped=true"
import script from "./ModalNormativa.vue?vue&type=script&lang=js"
export * from "./ModalNormativa.vue?vue&type=script&lang=js"
import style0 from "./ModalNormativa.vue?vue&type=style&index=0&id=6bee697e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee697e",
  null
  
)

export default component.exports